import type { RibbonControlDefinitionProps } from './RibbonControlDefinitionProps';
import type { MailboxInfo } from 'owa-client-types';
import { owaComputedFn } from 'owa-computed-fn';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { isMessageFileMailboxInfo } from 'owa-client-types/lib/MessageFileMailboxInfo';
import getGlobalSettingsAccountMailboxInfo from 'owa-account-source-list-store/lib/selectors/getGlobalSettingsAccountMailboxInfo';

/**
 * Since the `mailboxInfo` property on `RibbonControlDefinitionProps` can be `undefined`, this function can be used to ensure that `mailboxInfo` is always defined.
 * For MessageFile mailboxInfo, returns the global default account mailboxInfo instead since MessageFile doesn't have a real account.
 * @param mailboxInfo - The mailbox information from RibbonControlDefinitionProps or undefined
 * @returns mailboxInfo
 */
export const getRibbonMailboxInfo: (
    mailboxInfo: RibbonControlDefinitionProps['mailboxInfo']
) => MailboxInfo = owaComputedFn(function getRibbonMailboxInfo(
    mailboxInfo: RibbonControlDefinitionProps['mailboxInfo']
): MailboxInfo {
    const resolvedMailboxInfo = mailboxInfo ?? getModuleContextMailboxInfo();

    // Replace MessageFile mailboxInfo with global default account mailboxInfo to avoid coprincipal account errors
    // and to ensure folder operations work correctly
    if (isMessageFileMailboxInfo(resolvedMailboxInfo)) {
        return getGlobalSettingsAccountMailboxInfo();
    }

    return resolvedMailboxInfo;
});
